function deleteUser({ state, output, services }) {
  let user = state.get('client.delete.user')
  services.Http
    .post('/api/user/delete', { _id: user._id })
    .then(output.success)
    .catch(output.error)
}

deleteUser.async = true
deleteUser.outputs = ['success', 'error']

export default deleteUser



// WEBPACK FOOTER //
// ./src/modules/user/actions/deleteUser.js